// ===== QUANTITY SELECTOR =====
let qty = 1;
const qtyValue = document.getElementById('qtyValue');
document.getElementById('qtyMinus').addEventListener('click', () => {
  if (qty > 1) { qty--; qtyValue.textContent = qty; }
});
document.getElementById('qtyPlus').addEventListener('click', () => {
  qty++;
  qtyValue.textContent = qty;
});

// ===== SHOPIFY AJAX CART =====
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

async function fetchCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function updateCartUI() {
  const cart = await fetchCart();
  const count = cart.item_count;
  const badge = document.getElementById('cartBadge');
  if (badge) badge.textContent = count;
  const hdrCount = document.getElementById('cartHeaderCount');
  if (hdrCount) hdrCount.textContent = count > 0 ? '• ' + count : '';
  const totalEl = document.getElementById('cartTotal');
  if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  const reservEl = document.getElementById('cartReservation');
  if (reservEl) reservEl.classList.toggle('visible', count > 0);

  const body = document.getElementById('cartBody');
  if (cart.items.length === 0) {
    body.innerHTML = '<div class="cart-empty"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><p>Your cart is empty</p></div>';
    return;
  }
  body.innerHTML = cart.items.map((item, idx) => `
    <div class="cart-item">
      <div class="cart-item__img">
        ${item.image ? `<img src="${item.image}" alt="${item.product_title}" style="width:70px;height:70px;object-fit:cover;border-radius:8px;">` : '<span style="font-size:2rem">🛏️</span>'}
      </div>
      <div class="cart-item__info">
        <div class="cart-item__top">
          <div>
            <p class="cart-item__name">${item.product_title}</p>
            <p class="cart-item__brand">Cosseals</p>
          </div>
          <button class="cart-item__delete" onclick="removeItem(${idx + 1})">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
          </button>
        </div>
        <div class="cart-item__bottom">
          <div class="cart-item__qty-ctrl">
            <button onclick="changeCartQty(${idx + 1}, ${item.quantity - 1})">−</button>
            <span>${item.quantity}</span>
            <button onclick="changeCartQty(${idx + 1}, ${item.quantity + 1})">+</button>
          </div>
          <div class="cart-item__prices">
            ${item.compare_at_price > item.price ? `<span class="cart-item__compare">${formatMoney(item.compare_at_price * item.quantity)}</span>` : ''}
            <span class="cart-item__price">${formatMoney(item.price * item.quantity)}</span>
          </div>
        </div>
      </div>
    </div>
  `).join('');
}

async function changeCartQty(line, newQty) {
  if (newQty < 0) return;
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line, quantity: newQty })
  });
  await updateCartUI();
}

async function removeItem(line) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line, quantity: 0 })
  });
  await updateCartUI();
}

const FALLBACK_VARIANT_ID = 49260158910692;

async function addToCart(variantId, quantity) {
  const id = Number(variantId || FALLBACK_VARIANT_ID);
  await fetch('/cart/clear.js', { method: 'POST' });
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, quantity })
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.description || 'Could not add to cart');
  }
  await updateCartUI();
}

// ===== ADD TO CART BUTTON =====
document.getElementById('addToCart').addEventListener('click', async () => {
  const btn = document.getElementById('addToCart');
  const variantId = btn.dataset.variant || FALLBACK_VARIANT_ID;
  btn.disabled = true;
  btn.textContent = '...';
  try {
    await addToCart(variantId, qty);
    openCart();
    btn.textContent = '✓ Added to cart';
    btn.classList.add('added');
    setTimeout(() => {
      btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Add to cart';
      btn.classList.remove('added');
      btn.disabled = false;
    }, 2000);
  } catch(e) {
    btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Add to cart';
    btn.disabled = false;
  }
});

// ===== CART DRAWER =====
let _cartTimerInterval = null;
let _cartTimerSecs = 600;

function _tickCartTimer() {
  _cartTimerSecs--;
  if (_cartTimerSecs < 0) _cartTimerSecs = 599;
  const m = String(Math.floor(_cartTimerSecs / 60)).padStart(2, '0');
  const s = String(_cartTimerSecs % 60).padStart(2, '0');
  const el = document.getElementById('cartTimer');
  if (el) el.textContent = m + ':' + s;
}

function openCart() {
  document.getElementById('cartDrawer').classList.add('open');
  document.getElementById('cartOverlay').classList.add('open');
  if (!_cartTimerInterval) {
    _cartTimerSecs = 600;
    _tickCartTimer();
    _cartTimerInterval = setInterval(_tickCartTimer, 1000);
  }
}
function closeCart() {
  document.getElementById('cartDrawer').classList.remove('open');
  document.getElementById('cartOverlay').classList.remove('open');
}

document.getElementById('cartBtn').addEventListener('click', openCart);
document.getElementById('cartClose').addEventListener('click', closeCart);
document.getElementById('cartOverlay').addEventListener('click', closeCart);

document.querySelector('.btn-checkout').addEventListener('click', () => {
  window.location.href = '/checkout';
});

// ===== PACKAGE TABS =====
function switchPkgTab(tab, btn) {
  document.querySelectorAll('.pkg-tab').forEach(t => t.classList.remove('active'));
  document.querySelectorAll('.pkg-panel').forEach(p => p.classList.remove('active'));
  btn.classList.add('active');
  document.getElementById('pkg-' + tab).classList.add('active');
}

// ===== THERMOTRAC ACCORDION =====
function toggleTrac(id) {
  const item = document.getElementById(id);
  const isActive = item.classList.contains('active');
  document.querySelectorAll('.trac-card').forEach(el => {
    el.classList.remove('active');
    el.querySelector('.trac-card-trigger').setAttribute('aria-expanded', 'false');
  });
  if (!isActive) {
    item.classList.add('active');
    item.querySelector('.trac-card-trigger').setAttribute('aria-expanded', 'true');
  }
}

// ===== FAQ ACCORDION =====
document.querySelectorAll('.faq-question').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.faq-item');
    const answer = item.querySelector('.faq-answer');
    const isOpen = btn.classList.contains('open');
    document.querySelectorAll('.faq-question').forEach(b => {
      b.classList.remove('open');
      b.closest('.faq-item').querySelector('.faq-answer').style.display = 'none';
    });
    if (!isOpen) {
      btn.classList.add('open');
      answer.style.display = 'block';
    }
  });
});

// ===== MOBILE MENU =====
document.getElementById('menuToggle').addEventListener('click', () => {
  document.getElementById('nav').classList.toggle('open');
});

// ===== GALLERY THUMBNAILS =====
const mainImg = document.getElementById('mainImg');
const mainVideo = document.getElementById('mainVideo');
document.querySelectorAll('.thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    if (thumb.dataset.type === 'video') {
      mainImg.style.display = 'none';
      mainVideo.style.display = 'block';
      mainVideo.play();
    } else {
      mainVideo.style.display = 'none';
      mainVideo.pause();
      mainImg.style.display = 'block';
      mainImg.style.opacity = '0';
      setTimeout(() => {
        mainImg.src = thumb.dataset.img;
        mainImg.style.opacity = '1';
      }, 150);
    }
  });
});

// ===== SMOOTH SCROLL =====
document.querySelectorAll('a[href="#producto"]').forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault();
    document.getElementById('producto').scrollIntoView({ behavior: 'smooth' });
  });
});

// ===== STICKY HEADER SHADOW =====
window.addEventListener('scroll', () => {
  const header = document.getElementById('header');
  header.style.boxShadow = window.scrollY > 10
    ? '0 2px 20px rgba(0,0,0,0.1)'
    : '0 1px 8px rgba(0,0,0,0.05)';
});

// ===== STICKY BUY BAR =====
let stickyQty = 1;
const stickyBar = document.getElementById('stickyBar');
const addToCartBtn = document.getElementById('addToCart');
const UNIT_PRICE_CENTS = 11973; // $119.73

function updateStickyPrice() {
  const priceEl = document.getElementById('stickyPrice');
  const qtyEl = document.getElementById('stickyQty');
  if (priceEl) priceEl.textContent = '$' + (UNIT_PRICE_CENTS * stickyQty / 100).toFixed(2);
  if (qtyEl) qtyEl.textContent = stickyQty;
}
updateStickyPrice();

document.getElementById('stickyMinus').addEventListener('click', () => {
  if (stickyQty > 1) { stickyQty--; updateStickyPrice(); }
});
document.getElementById('stickyPlus').addEventListener('click', () => {
  stickyQty++;
  updateStickyPrice();
});

document.getElementById('stickyAddToCart').addEventListener('click', async () => {
  const variantId = document.getElementById('addToCart').dataset.variant || FALLBACK_VARIANT_ID;
  await addToCart(variantId, stickyQty);
  openCart();
});

window.addEventListener('scroll', () => {
  const bottom = addToCartBtn.getBoundingClientRect().bottom;
  const show = bottom < 0;
  stickyBar.classList.toggle('visible', show);
  document.body.style.paddingBottom = show ? stickyBar.offsetHeight + 'px' : '';
});

// ===== NEWSLETTER =====
function handleNewsletterSubmit(e) {
  e.preventDefault();
  const input = e.target.querySelector('input');
  const btn = e.target.querySelector('button');
  btn.textContent = '✓ Subscribed!';
  btn.style.background = '#22c55e';
  btn.style.color = '#fff';
  input.value = '';
  setTimeout(() => {
    btn.textContent = 'Submit';
    btn.style.background = '';
    btn.style.color = '';
  }, 3000);
}

// ===== META PIXEL EVENTS =====
function fbTrack(event, params) {
  if (typeof fbq === 'function') fbq('track', event, params || {});
}

// ViewContent on page load
fbTrack('ViewContent', {
  content_name: 'Cosseal Pillow™ Official',
  content_ids: ['49260158910692'],
  content_type: 'product',
  value: 119.73,
  currency: 'USD'
});

// Patch addToCart to fire AddToCart event
const _origAddToCart = addToCart;
window.addToCart = async function(variantId, quantity) {
  await _origAddToCart(variantId, quantity);
  fbTrack('AddToCart', {
    content_ids: ['49260158910692'],
    content_type: 'product',
    value: 119.73,
    currency: 'USD'
  });
};

// InitiateCheckout on checkout button
document.querySelector('.btn-checkout').addEventListener('click', () => {
  fbTrack('InitiateCheckout', {
    content_ids: ['49260158910692'],
    content_type: 'product',
    value: 119.73,
    currency: 'USD',
    num_items: 1
  });
});

// ===== INIT =====
updateCartUI();
